import styled from 'styled-components';
import background from '../../images/background.webp';
import mobile from '../../images/laptopDark.jpg';

const ContainerMain = styled.div`
  background-image: url(${mobile});
  background-size: auto !important;
  background-position: inherit !important;
  background-repeat: no-repeat !important;
  
  @media screen and (min-width: 800px) {
      background-size: cover !important;
      background-image: url(${background});
      background-attachment: fixed !important;
      background-position: center center !important;
  }
`;

export { ContainerMain };